import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toPriorityIcon' })
export class PriorityIconPipe implements PipeTransform {
  transform(value?: number): string {
    if (value) {
      return '<span class="material-symbols-outlined text-success">keyboard_double_arrow_up</span>';
    } else {
      return '';
    }
  }
}
